import OnlineOrderService from "services/OnlineOrderService";
import { ONLINE_ORDER_STATUS } from "const";

export const extractOnlineOrders = (response) => {
  return Array.isArray(response) ? response : [];
};

export const getActiveOnlineOrdersFilterParams = () => ({
  statuses: `${ONLINE_ORDER_STATUS.PENDING},${ONLINE_ORDER_STATUS.PREPARING},${ONLINE_ORDER_STATUS.READY}`,
});

const OnlineOrderHelper = {
  fetchOnlineOrders: async () => {
    const params = getActiveOnlineOrdersFilterParams();
    const response = await OnlineOrderService.getOnlineOrders(params);
    const orders = extractOnlineOrders(response);
    return orders;
  },

  getOnlineOrder: async (id) => {
    const order = await OnlineOrderService.getOnlineOrder(id);
    return order;
  },

  updateOnlineOrder: async (orderId, updates = {}) => {
    if (!orderId) {
      console.error("updateOnlineOrder: Order ID is required");
      return null;
    }

    try {
      const res = await OnlineOrderService.updateOnlineOrder(orderId, updates);
      return res;
    } catch (err) {
      console.error(`Failed to update online order #${orderId}:`, err);
      throw err;
    }
  },
};

export default OnlineOrderHelper;
